module.exports = __webpack_public_path__ + "static/media/Landing.c7875153.svg";